// extracted by mini-css-extract-plugin
export default {"MedicalClaimsPanelContainer":"eh_8zOP5"};